import React, { useState, useEffect } from 'react'

import { calculateTimeDifference } from '../common/formatUtils'

interface LiveDurationProps {
  raisedTime: Date
  clearedTime?: Date | null
  className?: string
}

export default function LiveDuration({ raisedTime, clearedTime, className }: LiveDurationProps) {
  const [duration, setDuration] = useState(() => calculateTimeDifference(raisedTime, clearedTime ?? new Date()))
  const isCleared = !!clearedTime

  useEffect(() => {
    if (clearedTime) {
      setDuration(calculateTimeDifference(raisedTime, clearedTime))
      return
    }

    const intervalId = setInterval(() => {
      setDuration(calculateTimeDifference(raisedTime, new Date()))
    }, 1000)

    return () => clearInterval(intervalId)
  }, [raisedTime, clearedTime])

  return (
    <div className={`inline-flex items-center gap-2 whitespace-nowrap ${className}`}>
      {isCleared ? (
        <span className="inline-flex h-3 w-3 rounded-full"></span>
      ) : (
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent/50"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 border-2 border-accent"></span>
        </span>
      )}
      <span className="font-medium text-base-content">{duration}</span>
    </div>
  )
}
